// extracted by mini-css-extract-plugin
module.exports = {"root":"Quiz_root__d21LL","fullscreen":"Quiz_fullscreen__V7D42","closeButton":"Quiz_closeButton__Gdlrm"};